import { render } from "./EditAttendance.vue?vue&type=template&id=0d2237c8&scoped=true"
import script from "./EditAttendance.vue?vue&type=script&lang=js"
export * from "./EditAttendance.vue?vue&type=script&lang=js"

import "./edit-attendance.scss?vue&type=style&index=0&id=0d2237c8&lang=scss&scoped=true"

import exportComponent from "/Users/soil2sons/Projects/Work/Ensibuuko/hrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2237c8"]])

export default __exports__